function _(a,n,r){var e=a(172);r.Canvas=e.Canvas;var s=a(176);r.CartesianFrame=s.CartesianFrame}
//# sourceMappingURL=index.min.js.map